import React from 'react'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import {MailAddrForm} from './mailaddrform.react.js'
import {MsgBox} from './msgbox.react.js'

const ResetForm = React.createClass({
  getInitialState() {
    return {
      showMsgBox: false,
    };
  },

  onResetPassword(e, mailaddr) {
    this.props.close(e)

    const vals = {
      mailaddr,
    };

    // post login
    $.ajax({
      url: '/submit_reset_password',
      type: 'POST',
      data:vals
    }).done((data) => {
      if (data.result) {
        this.setState({showMsgBox:true})
      }
      else {
        alert("正しいメールアドレスを入力してください")
      }
    })
  },

  close(e) {
    this.setState({showMsgBox:false})
  },

  render: function() {
    return (
      <div>
        <MsgBox showModal={this.state.showMsgBox} close={this.close} caption='パスワードの変更'
          msg={`確認用のメールを送信しました。
メールを確認して、リンクをクリックしてください。`}/>

        <MailAddrForm caption="パスワード再設定" okbutton="パスワードを変更する" showModal={this.props.showModal}
          close={this.props.close} onsubmit={this.onResetPassword}/>
      </div>
    )
  }
})

export const LoginForm = React.createClass({
  getInitialState(){
    return {
      isvalid:false,
      userid: '',
      password: '',
      errmsg: '',
      showResetForm: false
    }
  },

  setUserId(e) {
    this.setState({'userid': e.target.value.trim()})
  },

  setPassword(e) {
    this.setState({'password': e.target.value})
  },

  submit(e) {
    const vals = {
      userid: this.state.userid,
      passwd: this.state.password
    };

    // post login
    $.ajax({
      url: '/login',
      type: 'POST',
      data:vals
    }).done(data => {
      if (data.result) {
        location.href='/';
      }
      else {
        this.setState({errmsg: "正しいユーザID・パスワードを入力してください"})
      }
    })
  },

  onClickReset(e) {
    this.props.close()
    this.setState({showResetForm:true})
  },

  close(e) {
    if (e) {
      e.preventDefault()
    }
    this.setState({showResetForm:false})
  },

  render() {
    const is_invalid = (this.state.userid.length == 0 || this.state.password.length == 0)

    return (
      <div>
        <ResetForm  showModal={this.state.showResetForm} close={this.close} />
        <form className='modal fade form_userinfo' method='POST' autocomplete>
          <Modal show={this.props.showModal} onHide={this.props.close}>

            <Modal.Header closeButton>
              <Modal.Title>ログイン</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <label>ユーザID</label>
              <input name='userid' type="text" className="form-control input-userid"
                placeholder="ユーザIDを入力してください" autofocus onChange={this.setUserId}/>

              <label>パスワード</label>
              <input name='password' type="password" className="form-control input-passwd"
                  placeholder="パスワードを入力してください" autofocus
                  onChange={this.setPassword} />
              {this.state.errmsg ? <div className="alert alert-danger" role="alert">{this.state.errmsg}</div>:null}
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.props.close}>キャンセル</Button>
              <Button type='submit' className='btn btn-primary' disabled={is_invalid}
                onClick={this.submit}>ログイン</Button>
            </Modal.Footer>

            <Modal.Body>
            <a href="#" onClick={this.onClickReset}>ユーザID/パスワードがわからなくなったら</a>
            </Modal.Body>

          </Modal>
        </form>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./components/login.react.js